// extracted by mini-css-extract-plugin
export var bottomText = "PartnerTrust-module--bottomText--u6NGv";
export var bottomTextWrapper = "PartnerTrust-module--bottomTextWrapper--T2r95";
export var cardsSection = "PartnerTrust-module--cardsSection--0ZM2N";
export var headerSection = "PartnerTrust-module--headerSection--l+R1q";
export var partnerTrustWrapper = "PartnerTrust-module--partnerTrustWrapper--vFr0c";
export var sectionTitle = "PartnerTrust-module--sectionTitle--4Fj3-";
export var sectionTitleWrapper = "PartnerTrust-module--sectionTitleWrapper--Aqlrq";
export var subtitle = "PartnerTrust-module--subtitle--CTLOy";
export var title = "PartnerTrust-module--title--5+EO1";